<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kq05Fq/images/cover.jpg?1704638968076" alt="This image is the cover for the book Iraq War, Modern Warfare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Iraq War, Modern Warfare
      </h1>
      <p class="bookDescription body article font2">
        <p>The Iraq War is a visual record of the American-led Operation Iraqi Freedom of 2003, which resulted in the dramatic overthrow of dictator Saddam Hussein. In a striking sequence of photographs Anthony Tucker-Jones shows how this was achieved by the American and British armed forces in a lightning campaign of just two weeks. But the photographs also show the disastrous aftermath when the swift victory was undermined by the outbreak of the Iraqi insurgency - in the Shia south, in Baghdad and the Sunni Triangle, and in Fallujah where two ferocious battles were fought. The author, who is an expert on the Iraqi armed forces and has written extensively on the Iran-Iraq War and the Gulf War, gives a fascinating insight into the Iraqi army and air force and into the multitude of weapons systems Saddam purchased from around the world. He also looks at the failures on the American and British side - the flaws in the tactics that were used, the poor performance of some of the armoured fighting vehicles  and at the reformed Iraqi armed forces who have now taken responsibility for security in the country. The Iraq War is a vivid photographic introduction to a conflict that has only just passed into history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Tucker-Jones
      </h2>
      
      <p class="authorDescription body article">Anthony Tucker-Jones is a former defense intelligence officer and a widely published expert on regional conflicts, counter-terrorism and armsred and aerial warfare. He is the author of over thirty books, is security and terrorism correspondent for intersec – The Journal of International Security, and has freelanced for Channel 4 News.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?345f26b2